/* FOCUS — Carrito rápido y estable.

   Un solo dueño de "añadir" y "cambiar pack". El clic NUNCA espera a que
   Shopify pinte HTML, y el cajón NUNCA se destruye al cambiar de pack.

   1. El cajón se abre al instante.
   2. Se habla con el carrito en JSON (añadir / cambiar / leer total).
   3. El HTML del cajón solo se pide al pasar de vacío a con productos,
      y se inserta por importación de nodos (no innerHTML) para no tumbar
      los bloques del tema.
   4. Cambiar de pack pinta precio y total al momento. Si pulsas varios
      seguidos, solo se envía el último. El HTML no se toca.
   5. Si el carrito ya tiene el producto, un CTA fija el pack (no apila).
   6. Un fallo nunca recarga la página ni deja el cajón en blanco. */

(function () {
  'use strict';

  /* Reloj de la oferta. NO arranca al entrar en la ficha: solo al añadir
     al carrito (14:59). Ficha y cajón leen el mismo estado. Si llega a
     cero EN ESTA visita se queda en 00:00 parpadeando. Un segundo añadir
     en la misma visita no reinicia el reloj. */
  if (!window.feOfertaTiempo) {
    var CLAVE_FIN = 'v2-oferta-fin';
    var CLAVE_CERO = 'v2-oferta-cero';
    var CLAVE_CART = 'v2-oferta-add';
    var COPY = {
      espera: {
        titulo: 'Tu oferta está reservada',
        pie: ''
      },
      normal: {
        titulo: 'Tu oferta está reservada',
        pie: 'Mantén tu precio especial mientras dure la reserva.'
      },
      aviso: {
        titulo: 'Quedan pocos minutos',
        pie: 'Completa el pedido para no perder este precio.'
      },
      urgente: {
        titulo: 'Últimos minutos',
        pie: 'El precio especial está a punto de caducar.'
      },
      critico: {
        titulo: 'Queda 1 minuto',
        pie: 'Si se acaba, puedes perder el precio especial.'
      },
      cero: {
        titulo: 'Últimos minutos',
        pie: 'Completa el pedido ahora para no perder la oferta.'
      }
    };

    function lee(almacen, clave) {
      try { return almacen.getItem(clave); } catch (e) { return null; }
    }
    function escribe(almacen, clave, valor) {
      try { almacen.setItem(clave, valor); } catch (e) {}
    }
    function borra(almacen, clave) {
      try { almacen.removeItem(clave); } catch (e) {}
    }
    function milisDe(minutos) {
      return (minutos > 0 ? minutos : 15) * 60 * 1000;
    }
    function faseDe(segundos, pendiente, cero) {
      if (pendiente) return 'espera';
      if (cero || segundos <= 0) return 'cero';
      if (segundos <= 60) return 'critico';
      if (segundos <= 120) return 'urgente';
      if (segundos <= 300) return 'aviso';
      return 'normal';
    }
    function armaEstado(restante, pendiente) {
      var cero = !pendiente && restante <= 0;
      if (cero) escribe(sessionStorage, CLAVE_CERO, '1');
      var segundos = pendiente ? 0 : (cero ? 0 : Math.floor(restante / 1000));
      var fase = faseDe(segundos, pendiente, cero);
      var copy = COPY[fase] || COPY.normal;
      return {
        pendiente: !!pendiente,
        segundos: segundos,
        cero: cero,
        fase: fase,
        urgente: fase === 'aviso' || fase === 'urgente' || fase === 'critico' || fase === 'cero',
        titulo: copy.titulo,
        pie: copy.pie
      };
    }

    window.feOfertaTiempo = {
      hayReserva: function () {
        if (lee(sessionStorage, CLAVE_CERO) === '1') return true;
        if (lee(sessionStorage, CLAVE_CART) !== '1') return false;
        var fin = parseInt(lee(localStorage, CLAVE_FIN), 10);
        return !!(fin && !isNaN(fin));
      },
      reservar: function (minutos) {
        var ahora = Date.now();
        if (lee(sessionStorage, CLAVE_CART) === '1') {
          var finActual = parseInt(lee(localStorage, CLAVE_FIN), 10);
          if (finActual && !isNaN(finActual) && finActual > ahora) return;
          if (lee(sessionStorage, CLAVE_CERO) === '1') return;
        }
        borra(sessionStorage, CLAVE_CERO);
        escribe(sessionStorage, CLAVE_CART, '1');
        escribe(localStorage, CLAVE_FIN, String(ahora + milisDe(minutos) - 1000));
        document.dispatchEvent(new CustomEvent('fev2:oferta'));
      },
      tick: function () {
        if (lee(sessionStorage, CLAVE_CERO) === '1') {
          return armaEstado(0, false);
        }
        if (lee(sessionStorage, CLAVE_CART) !== '1') {
          return armaEstado(0, true);
        }
        var fin = parseInt(lee(localStorage, CLAVE_FIN), 10);
        if (!fin || isNaN(fin)) {
          return armaEstado(0, true);
        }
        var ahora = Date.now();
        if (fin <= ahora) {
          return armaEstado(0, false);
        }
        return armaEstado(fin - ahora, false);
      }
    };
  }

  if (window.feCarrito) return;

  var SECCIONES = ['cart-drawer', 'cart-icon-bubble'];
  var addEnVuelo = false;
  var addCola = null;
  var packEnVuelo = null;
  var packCola = null;
  var packReloj = null;
  var claveGuardada = '';
  var varianteGuardada = '';

  function raiz() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function urlAdd() {
    return (window.routes && window.routes.cart_add_url) || (raiz() + 'cart/add');
  }
  function urlChange() {
    return (window.routes && window.routes.cart_change_url) || (raiz() + 'cart/change');
  }
  function urlCart() {
    return (window.routes && window.routes.cart_url) || (raiz() + 'cart');
  }
  function urlUpdate() {
    return (window.routes && window.routes.cart_update_url) || (raiz() + 'cart/update');
  }
  function cajon() { return document.querySelector('cart-drawer'); }

  function publica(ok, mensaje) {
    document.dispatchEvent(new CustomEvent('fev2:carrito', {
      detail: { ok: ok, mensaje: mensaje || '' }
    }));
  }

  function leeJson(r) {
    return r.text().then(function (t) {
      if (!t) return {};
      try { return JSON.parse(t); } catch (e) {
        return { status: 500, description: 'No hemos podido actualizar el carrito. Vuelve a intentarlo.' };
      }
    });
  }

  function monedaActiva() {
    if (window.feMercado && window.feMercado.moneda) return window.feMercado.moneda;
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return 'EUR';
  }

  function formateaMxn(centimos) {
    var pesos = Math.round(Math.abs(Number(centimos) || 0) / 100);
    return '$' + pesos.toLocaleString('es-MX');
  }

  // La tabla de precios de pack la manda el servidor dentro del propio cajón,
  // en el atributo data-fe-packs que pone snippets/fe-carrito-packs.liquid, y
  // ya viene en la moneda del visitante. Este guion no lleva ningún importe
  // escrito: cuando los llevaba, se quedaron en los precios de la v1 y el
  // "Ahorras" restaba sobre 69,99 € mientras el pack costaba 49,99 €.
  function tablaPacks() {
    var el = document.querySelector('[data-fe-packs]');
    var crudo = el && el.getAttribute('data-fe-packs');
    if (!crudo) return {};
    var filas;
    try {
      filas = JSON.parse(crudo);
    } catch (e) {
      return {};
    }
    var tabla = {};
    (filas || []).forEach(function (fila) {
      if (fila && fila.cantidad) tabla[String(fila.cantidad)] = fila;
    });
    return tabla;
  }

  function packDeTabla(cantidad) {
    return tablaPacks()[String(cantidad)] || null;
  }

  function precioPackCents(cantidad) {
    var fila = packDeTabla(cantidad);
    return fila ? Number(fila.ahora) || 0 : 0;
  }

  function formatea(centimos, elRef) {
    if (monedaActiva() === 'MXN') return formateaMxn(centimos);
    var nums = (Math.abs(centimos) / 100).toFixed(2).replace('.', ',');
    var actual = elRef && elRef.textContent ? elRef.textContent.trim() : '';
    if (actual.charAt(0) === '€') {
      return '€' + nums + actual.replace(/^€[\d.,]+/, '');
    }
    return nums + ' €';
  }

  function pintaBurbuja(n) {
    document.querySelectorAll('#cart-icon-bubble, [data-fe-abre-carrito]').forEach(function (icono) {
      var burbuja = icono.querySelector('.cart-count-bubble');
      if (n <= 0) {
        if (burbuja && burbuja.parentNode) burbuja.parentNode.removeChild(burbuja);
      } else {
        if (!burbuja) {
          burbuja = document.createElement('div');
          burbuja.className = 'cart-count-bubble';
          icono.appendChild(burbuja);
        }
        burbuja.innerHTML = n < 100
          ? '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + '</span>'
          : '<span class="visually-hidden">' + n + '</span>';
      }
    });
    var unidades = document.querySelector('[data-fe-cart-unidades]');
    if (unidades) {
      if (n > 0) {
        unidades.hidden = false;
        unidades.textContent = ' · ' + n;
      } else {
        unidades.hidden = true;
      }
    }
  }

  function bloqueaPagar(si) {
    ['CartDrawer-Checkout', 'checkout'].forEach(function (id) {
      var b = document.getElementById(id);
      if (!b) return;
      b.disabled = !!si;
      if (si) b.setAttribute('aria-busy', 'true');
      else b.removeAttribute('aria-busy');
    });
  }

  function abreCajon(conCarga) {
    var el = cajon();
    if (!el) return;
    el.classList.remove('is-empty');
    var lista = el.querySelector('cart-drawer-items');
    if (lista) lista.classList.remove('is-empty');
    marcaCarga(!!conCarga);
    if (typeof el.open === 'function') el.open();
    else {
      el.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
  }

  function marcaCarga(si) {
    var el = cajon();
    if (!el) return;
    el.classList.toggle('fe-cart--pintando', !!si);
    var overlay = el.firstElementChild && el.firstElementChild.classList.contains('fe-cart-pintando')
      ? el.firstElementChild
      : el.querySelector('.fe-cart-pintando');
    if (overlay) {
      overlay.hidden = !si;
      overlay.setAttribute('aria-hidden', si ? 'false' : 'true');
    }
  }

  function cierraCarga() {
    marcaCarga(false);
  }

  function hayLinea() {
    return !!document.querySelector('cart-drawer .cart-item, cart-items .cart-item');
  }

  function lineaActual() {
    var input = document.querySelector(
      'cart-drawer .cart-item [data-quantity-line-key], cart-items .cart-item [data-quantity-line-key]'
    );
    if (input) {
      var clave = input.getAttribute('data-quantity-line-key') || '';
      if (clave) {
        return {
          key: clave,
          variant: input.getAttribute('data-quantity-variant-id') || ''
        };
      }
    }
    if (hayLinea() && claveGuardada) {
      return { key: claveGuardada, variant: varianteGuardada || '' };
    }
    return null;
  }

  function guardaLinea(cartOLinea) {
    if (!cartOLinea) return;
    var linea = cartOLinea.items && cartOLinea.items[0] ? cartOLinea.items[0] : cartOLinea;
    if (linea && linea.key) claveGuardada = String(linea.key);
    if (linea && (linea.variant_id || linea.id)) {
      varianteGuardada = String(linea.variant_id || linea.id);
    }
    if (!claveGuardada) return;
    document.querySelectorAll('[data-linea-key]').forEach(function (el) {
      if (el.hasAttribute('data-fe-cart-talla') || el.hasAttribute('data-fe-cart-talla-qty') || el.hasAttribute('data-fe-cart-quita')) return;
      if (el.closest && el.closest('.cart-item--kids')) return;
      el.setAttribute('data-linea-key', claveGuardada);
    });
  }

  function nodoDeHtml(html, selector) {
    if (!html || typeof html !== 'string') return null;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector(selector);
    } catch (e) {
      return null;
    }
  }

  function morph(destino, origen) {
    if (!destino || !origen || !destino.parentNode) return false;
    try {
      if (typeof window.removeTrapFocus === 'function') {
        try { window.removeTrapFocus(); } catch (e) {}
      }
      destino.replaceWith(document.importNode(origen, true));
      return true;
    } catch (e) {
      return false;
    }
  }

  function reatrapaFoco() {
    var el = cajon();
    if (!el || !el.classList.contains('active')) return;
    var caja = document.getElementById('CartDrawer') || el.querySelector('.drawer__inner');
    var foco = el.querySelector('.drawer__inner') || el.querySelector('.drawer__close');
    if (!caja || !foco || typeof window.trapFocus !== 'function') return;
    try { window.trapFocus(caja, foco); } catch (e) {}
  }

  function pintaSecciones(sections, itemCount) {
    if (!sections) return hayLinea();
    var origen = nodoDeHtml(sections['cart-drawer'], '#CartDrawer');
    var destino = document.querySelector('#CartDrawer');
    if (origen && destino) morph(destino, origen);

    var htmlBurbuja = sections['cart-icon-bubble'];
    var burbuja = document.querySelector('#cart-icon-bubble');
    if (burbuja && htmlBurbuja) {
      var doc = nodoDeHtml(htmlBurbuja, '#cart-icon-bubble') ||
        nodoDeHtml(htmlBurbuja, '.shopify-section');
      if (doc) burbuja.innerHTML = doc.innerHTML;
    }

    var el = cajon();
    var lista = document.querySelector('cart-drawer-items');
    if (typeof itemCount === 'number') {
      if (itemCount > 0) {
        if (el) el.classList.remove('is-empty');
        if (lista) lista.classList.remove('is-empty');
      } else {
        if (el) el.classList.add('is-empty');
        if (lista) lista.classList.add('is-empty');
      }
    }
    reatrapaFoco();
    cierraCarga();
    if (typeof window.fePintaReserva === 'function') window.fePintaReserva();
    pintaSeguirKids();
    return hayLinea();
  }

  function pintaSeguirKids() {
    var el = cajon();
    if (!el || !el.classList.contains('cart-drawer--kids')) return;
    var destino = '/products/almohada-ergonomica-infantil';
    el.querySelectorAll('.drawer__inner-empty a.button, [data-fe-seguir-kids]').forEach(function (a) {
      a.setAttribute('href', destino);
    });
  }

  function pideSecciones() {
    var path = window.location.pathname || '/';
    var sep = path.indexOf('?') === -1 ? '?' : '&';
    return fetch(path + sep + 'sections=' + SECCIONES.join(',') + '&_=' + Date.now(), {
      headers: { Accept: 'application/json', 'Cache-Control': 'no-store' },
      cache: 'no-store'
    }).then(leeJson);
  }

  function cuentaDeRespuesta(respuesta, cart) {
    if (cart && typeof cart.item_count === 'number') return cart.item_count;
    if (respuesta && typeof respuesta.item_count === 'number') return respuesta.item_count;
    if (respuesta && respuesta.items && respuesta.items.length) {
      var n = 0;
      respuesta.items.forEach(function (it) { n += it.quantity || 1; });
      return n;
    }
    if (respuesta && respuesta.quantity) return respuesta.quantity;
    return undefined;
  }

  function pideCart() {
    return fetch(urlCart() + '.js?_=' + Date.now(), {
      headers: { Accept: 'application/json', 'Cache-Control': 'no-store' },
      cache: 'no-store'
    }).then(leeJson);
  }

  function filasDesglose(pack) {
    var gratis = pack.pares - pack.pagos;
    return '<p class="fe-cart-desglose__resumen">Te llevas ' + pack.pares + ' pares</p>'
      + '<p class="fe-cart-desglose__trato">'
      + '<span>Pagas ' + pack.pagos + '</span>'
      + '<span class="fe-cart-desglose__mas" aria-hidden="true">+</span>'
      + '<span class="fe-cart-desglose__gratis">' + gratis + ' GRATIS</span>'
      + '</p>';
  }

  function pintaPackLocal(cantidad) {
    if (!document.querySelector('.fe-cart-packs__opcion')) return;
    var qty = String(cantidad);
    var n = parseInt(cantidad, 10) || 0;
    var precioTexto = '';
    document.querySelectorAll('.fe-cart-packs__opcion').forEach(function (o) {
      var activa = o.getAttribute('data-cantidad') === qty;
      o.classList.toggle('fe-cart-packs__opcion--activa', activa);
      o.setAttribute('aria-pressed', activa ? 'true' : 'false');
      if (o.getAttribute('data-cantidad') === '6' && n !== 6) {
        var wrap = o.closest('.fe-cart-packs-wrap');
        var tresActivo = wrap && wrap.hasAttribute('data-fe-pack-3x3');
        if (!tresActivo) o.hidden = true;
      }
      if (activa) {
        o.removeAttribute('data-fe-cart-subir');
        var p = o.querySelector('.fe-cart-packs__precio');
        if (p) precioTexto = p.textContent.trim();
      } else {
        o.setAttribute('data-fe-cart-subir', '');
      }
    });
    document.querySelectorAll('[data-fe-cart-upsell]').forEach(function (el) {
      el.hidden = n >= 4;
    });
    document.querySelectorAll('[data-fe-cart-garantia]').forEach(function (el) {
      if (el.hasAttribute('data-fe-cart-kids')) return;
      var min = parseInt(el.getAttribute('data-fe-pack-min') || '4', 10);
      el.hidden = n < min;
    });
    document.querySelectorAll('details.fe-cart-packs').forEach(function (el) {
      el.removeAttribute('open');
    });
    // El texto de la oferta es igual en todos los mercados; los importes
    // salen de la tabla que manda el servidor.
    var copia = {
      '2': { titulo: 'OFERTA 1+1 GRATIS', pares: 2, pagos: 1 },
      '4': { titulo: 'OFERTA 2+2 GRATIS', pares: 4, pagos: 2 },
      '6': { titulo: 'OFERTA 3+3 GRATIS', pares: 6, pagos: 3 }
    }[qty];
    var pack = null;
    if (copia) {
      var precios = packDeTabla(qty);
      pack = {
        titulo: copia.titulo,
        pares: copia.pares,
        pagos: copia.pagos,
        antes: precios ? Number(precios.antes) || 0 : 0,
        ahorro: precios ? Number(precios.ahorro) || 0 : 0
      };
    }
    if (pack) {
      document.querySelectorAll('[data-fe-pack-titulo]').forEach(function (el) {
        el.textContent = pack.titulo;
      });
      document.querySelectorAll('[data-fe-pack-desglose]').forEach(function (lista) {
        lista.innerHTML = filasDesglose(pack);
      });
    }
    if (precioTexto) {
      document.querySelectorAll('.totals__total-value').forEach(function (el) {
        el.textContent = el.textContent.trim().charAt(0) === '€'
          ? '€' + precioTexto.replace(/[^\d,]/g, '') + el.textContent.trim().replace(/^€[\d.,]+/, '')
          : precioTexto;
      });
      document.querySelectorAll('[data-fe-pack-precio], .cart-item__price-wrapper .price').forEach(function (el) {
        if (el.closest('s') || el.matches('s')) return;
        if (el.closest('.cart-item--kids')) return;
        el.textContent = el.textContent.trim().charAt(0) === '€'
          ? '€' + precioTexto.replace(/[^\d,]/g, '')
          : precioTexto;
      });
    }
    if (pack && pack.antes > 0) {
      document.querySelectorAll('[data-fe-pack-antes]').forEach(function (el) {
        el.hidden = !pack.ahorro;
        el.textContent = formatea(pack.antes, el);
      });
    }
    document.querySelectorAll('[data-fe-pack-ahorro]').forEach(function (el) {
      if (!pack || !pack.ahorro) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      el.textContent = 'Ahorras ' + formatea(pack.ahorro, el);
    });
    document.querySelectorAll('.quantity__input').forEach(function (input) {
      if (input.closest('.cart-item--kids')) return;
      input.value = qty;
    });
  }

  function esLineaKids(it) {
    if (!it) return false;
    var props = it.properties || {};
    if (props.Almohada || props._almohada) return true;
    var handle = String(it.handle || '');
    var url = String(it.url || '');
    return handle.indexOf('almohada-ergonomica-infantil') !== -1
      || url.indexOf('almohada-ergonomica-infantil') !== -1;
  }

  function packDeItem(it) {
    var i;
    var opts = it && it.options_with_values;
    if (opts && opts.length) {
      for (i = 0; i < opts.length; i++) {
        if (String(opts[i].name || '').toLowerCase() === 'pack') {
          return parseInt(opts[i].value, 10) || 1;
        }
      }
    }
    if (it && it.options && !Array.isArray(it.options) && it.options.Pack) {
      return parseInt(it.options.Pack, 10) || 1;
    }
    if (it && Array.isArray(it.options) && it.options.length >= 3) {
      return parseInt(it.options[2], 10) || 1;
    }
    if (it && Array.isArray(it.variant_options) && it.variant_options.length >= 3) {
      return parseInt(it.variant_options[2], 10) || 1;
    }
    return 1;
  }

  function unidadesKids(it) {
    var pack = packDeItem(it);
    var qty = (it && it.quantity) || 1;
    return pack > 1 ? pack : qty;
  }

  function cuentaKids(cart) {
    var n = 0;
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      if (esLineaKids(it)) n += unidadesKids(it);
    });
    return n;
  }

  function kidsVariantes() {
    var nodo = document.getElementById('fe-kids-variantes');
    if (!nodo) return [];
    try { return JSON.parse(nodo.textContent); } catch (e) { return []; }
  }

  function kidsNorm(s) {
    return String(s || '').replace(/[–—]/g, '-').trim();
  }

  function kidsIdDe(edad, pack) {
    var p = String(pack);
    var e = kidsNorm(edad);
    var lista = kidsVariantes();
    var i;
    for (i = 0; i < lista.length; i++) {
      if (kidsNorm(lista[i].edad) === e && String(lista[i].pack) === p) return String(lista[i].id);
    }
    return kidsIdPorEdad(edad);
  }

  function kidsIdPorEdad(edad) {
    var lista = kidsVariantes();
    var e = kidsNorm(edad);
    var i;
    for (i = 0; i < lista.length; i++) {
      if (kidsNorm(lista[i].edad) === e) return String(lista[i].id);
    }
    return '';
  }

  function kidsEdadesDe(nodo) {
    var edades = [];
    var linea = nodo && nodo.closest ? nodo.closest('.cart-item') : null;
    if (!linea) return edades;
    var slots = linea.querySelectorAll('[data-fe-cart-slot]');
    if (slots.length) {
      slots.forEach(function (sel) {
        if (sel.value) edades.push(sel.value);
      });
    } else {
      var mix = linea.querySelectorAll('[data-fe-cart-talla-qty]');
      if (mix.length) {
        mix.forEach(function (sel) {
          var edad = sel.getAttribute('data-fe-cart-talla-qty');
          var n = parseInt(sel.getAttribute('data-qty-actual'), 10);
          if (isNaN(n)) n = parseInt(sel.value, 10) || 0;
          var i;
          for (i = 0; i < n; i++) edades.push(edad);
        });
      } else {
        linea.querySelectorAll('[data-fe-cart-talla]').forEach(function (sel) {
          if (sel.value) edades.push(sel.value);
        });
      }
    }
    var caja = linea.querySelector('[data-fe-kids-qty]');
    var pack = caja ? parseInt(caja.getAttribute('data-pack'), 10) : edades.length;
    if (edades.length > 0 && pack > edades.length) return kidsAjustaEdades(edades, pack);
    if (pack > 0 && edades.length > pack) return edades.slice(0, pack);
    return edades;
  }

  function kidsEdadesDeItemJs(it) {
    var props = it.properties || {};
    var out = [];
    var i;
    for (i = 1; i <= 3; i++) {
      if (props['Edad ' + i]) out.push(props['Edad ' + i]);
    }
    if (out.length) {
      var nProp = Math.min(3, unidadesKids(it));
      while (out.length < nProp) out.push(out[out.length - 1]);
      return out.slice(0, nProp);
    }
    var n = Math.min(3, unidadesKids(it));
    var edad = '';
    if (it.variant_options && it.variant_options[0]) edad = it.variant_options[0];
    else if (Array.isArray(it.options) && it.options[0]) edad = it.options[0];
    else if (it.options && it.options.Edad) edad = it.options.Edad;
    for (i = 0; i < n; i++) out.push(edad || '1–3 años');
    return out;
  }

  function kidsEdadesDePackItems(items) {
    var out = [];
    (items || []).forEach(function (it) {
      var props = it.properties || {};
      var hay = false;
      var i;
      for (i = 1; i <= 3; i++) {
        if (props['Edad ' + i]) {
          out.push(props['Edad ' + i]);
          hay = true;
        }
      }
      if (!hay) {
        var q = parseInt(it.quantity, 10) || 1;
        for (i = 0; i < q && out.length < 3; i++) out.push('');
      }
    });
    return out.filter(Boolean).slice(0, 3);
  }

  function kidsGruposDe(edades) {
    var grupos = [];
    var idx = {};
    (edades || []).forEach(function (edad) {
      var k = kidsNorm(edad);
      if (!k) return;
      if (idx[k] == null) {
        idx[k] = grupos.length;
        grupos.push({ edad: edad, n: 0 });
      }
      if (grupos[idx[k]].n < 3) grupos[idx[k]].n += 1;
    });
    return grupos;
  }

  function kidsItemsDeEdades(edades) {
    var grupos = kidsGruposDe(edades);
    var items = [];
    var i;
    var g;
    for (i = 0; i < grupos.length; i++) {
      g = grupos[i];
      var id = kidsIdDe(g.edad, g.n);
      if (!id) return null;
      var props = {};
      var j;
      for (j = 0; j < g.n; j++) props['Edad ' + (j + 1)] = g.edad;
      items.push({ id: Number(id), quantity: 1, properties: props });
    }
    return items;
  }

  function kidsUnicasDe(edades) {
    var unicas = [];
    (edades || []).forEach(function (edad) {
      var k = kidsNorm(edad);
      if (k && unicas.indexOf(k) === -1) unicas.push(k);
    });
    return unicas;
  }

  function kidsPagoDe(n) {
    n = parseInt(n, 10) || 0;
    if (n <= 0) return 0;
    if (n === 1) return 4495;
    if (n === 2) return 7195;
    return 9495 + Math.max(0, n - 3) * 3165;
  }

  function kidsListaDe(n) {
    return Math.max(0, (parseInt(n, 10) || 0) * 4495);
  }

  function kidsTotalMostrar(cart) {
    var kidsN = cuentaKids(cart);
    var total = (cart && cart.total_price) || 0;
    if (kidsN <= 0) return total;
    var shopifyKids = 0;
    (cart.items || []).forEach(function (it) {
      if (!esLineaKids(it)) return;
      shopifyKids += it.final_line_price || it.line_price || 0;
    });
    return total - shopifyKids + kidsPagoDe(kidsN);
  }

  function kidsPintaPreciosYa(n) {
    var pago = kidsPagoDe(n);
    var lista = kidsListaDe(n);
    var ahorro = Math.max(0, lista - pago);
    document.querySelectorAll('.totals__total-value').forEach(function (el) {
      el.textContent = formatea(pago, el);
    });
    var precios = document.querySelectorAll('.cart-item--kids:not(.cart-item--kids-desglose) [data-fe-kids-precio]');
    if (precios.length !== 1) return;
    precios[0].textContent = formatea(pago, precios[0]);
    document.querySelectorAll('.cart-item--kids:not(.cart-item--kids-desglose) [data-fe-kids-antes]').forEach(function (el) {
      el.textContent = formatea(lista, el);
      el.hidden = ahorro <= 0;
    });
    document.querySelectorAll('.cart-item--kids:not(.cart-item--kids-desglose) .fe-cart-linea-ahorro').forEach(function (el) {
      if (ahorro <= 0) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      el.textContent = 'Ahorras ' + formatea(ahorro, el);
    });
  }

  function kidsClavesDom() {
    var seen = {};
    var out = [];
    document.querySelectorAll('.cart-item--kids [data-linea-key], .cart-item--kids [data-quantity-line-key]').forEach(function (el) {
      var k = el.getAttribute('data-linea-key') || el.getAttribute('data-quantity-line-key');
      if (k && !seen[k]) {
        seen[k] = 1;
        out.push(k);
      }
    });
    return out;
  }

  function kidsPedidoRoto(cart) {
    var kids = (cart && cart.items ? cart.items : []).filter(esLineaKids);
    if (kids.length === 0) return false;
    if (kids.length > 1) return true;
    var it = kids[0];
    if ((it.quantity || 1) !== 1) return true;
    var pack = packDeItem(it);
    var edades = kidsEdadesDeItemJs(it);
    if (pack !== edades.length || pack < 1 || pack > 3) return true;
    return false;
  }

  var kidsEscribiendo = false;
  var kidsIgnoraHasta = 0;
  var kidsFirmaEscrita = '';
  var kidsPendiente = null;
  var kidsDebTimer = 0;
  var kidsDebEdades = null;

  // Junta cambios de talla seguidos (talla 1 y luego talla 2) en UNA sola
  // escritura: sin esto, el segundo cambio caía mientras se escribía el primero
  // y el <select> volvía atrás al repintar (bug "se rompe el carrito").
  function kidsEscribePedidoDeb(edades) {
    kidsDebEdades = edades;
    clearTimeout(kidsDebTimer);
    kidsDebTimer = setTimeout(function () {
      var e = kidsDebEdades;
      kidsDebEdades = null;
      kidsEscribePedido(e);
    }, 450);
  }

  function kidsFirma(edades) {
    return (edades || []).map(function (edad) { return kidsNorm(edad); }).join('|');
  }

  function kidsCallar(ms) {
    kidsIgnoraHasta = Date.now() + (ms || 600);
  }

  function kidsIgnora() {
    return kidsEscribiendo || Date.now() < kidsIgnoraHasta;
  }

  function kidsQuitaClaves(claves) {
    if (!claves || !claves.length) return Promise.resolve({});
    var updates = {};
    claves.forEach(function (k) { updates[k] = 0; });
    return fetchTope(urlUpdate() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (res && res.status) return Promise.reject(res);
      return res;
    });
  }

  function kidsEdadesDePedido(salvoFila, reemplazo) {
    var out = [];
    document.querySelectorAll('.cart-item--kids').forEach(function (fila) {
      if (salvoFila && fila === salvoFila) {
        if (reemplazo && reemplazo.length) out = out.concat(reemplazo);
        return;
      }
      out = out.concat(kidsEdadesDe(fila));
    });
    return out.filter(Boolean).slice(0, 3);
  }

  function kidsEscribePedido(edades) {
    edades = (edades || []).filter(Boolean).slice(0, 3);
    if (kidsEscribiendo) {
      // Otro cambio de talla mientras se escribía: se guarda el último y se
      // aplica al terminar, en vez de perderlo (era el bug del carrito kids).
      kidsPendiente = edades;
      return Promise.resolve();
    }
    var firma = kidsFirma(edades);
    if (edades.length && firma === kidsFirmaEscrita) return Promise.resolve();
    var item = null;
    if (edades.length) {
      var id = kidsIdDe(edades[0], edades.length);
      if (!id) return Promise.resolve();
      item = { id: Number(id), quantity: 1, properties: kidsPropsDe(edades) };
    }
    kidsEscribiendo = true;
    kidsCallar(1200);
    window.__feKidsLock = true;
    bloqueaPagar(true);
    kidsPintaPreciosYa(edades.length);
    var claves = kidsClavesDom();
    function anade() {
      if (!item) {
        return pideSecciones().then(function (s) {
          pintaSecciones(s, 0);
          return {};
        });
      }
      return fetchTope(urlAdd() + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [item],
          sections: SECCIONES.join(','),
          sections_url: window.location.pathname || '/'
        })
      });
    }
    function conClaves() {
      if (!claves.length) return pideCart().then(function (cart) {
        claves = (cart.items || []).filter(esLineaKids).map(function (it) { return it.key; });
        if (!claves.length) return anade();
        return kidsQuitaClaves(claves).then(anade);
      });
      return kidsQuitaClaves(claves).then(anade);
    }
    return conClaves().then(function (addRes) {
      if (addRes && addRes.status) return Promise.reject(addRes);
      var secs = addRes && addRes.sections;
      if (secs) {
        pintaSecciones(secs);
        kidsFirmaEscrita = firma;
        kidsCallar(600);
        return addRes;
      }
      return pideSecciones().then(function (s) {
        pintaSecciones(s);
        kidsFirmaEscrita = firma;
        kidsCallar(600);
        return addRes;
      });
    }).then(function (res) {
      kidsEscribiendo = false;
      window.__feKidsLock = false;
      kidsCallar(400);
      bloqueaPagar(false);
      cierraCarga();
      return res;
    }).catch(function () {
      kidsEscribiendo = false;
      window.__feKidsLock = false;
      kidsCallar(400);
      bloqueaPagar(false);
      cierraCarga();
      return pideSecciones().then(function (secs) {
        pintaSecciones(secs);
      }).catch(function () {});
    }).then(function (res) {
      // Drenar el último cambio que llegó mientras se escribía.
      if (kidsPendiente) {
        var sig = kidsPendiente;
        kidsPendiente = null;
        if (kidsFirma(sig) !== kidsFirmaEscrita) return kidsEscribePedido(sig);
      }
      return res;
    });
  }

  function kidsReparaSiHaceFalta(cart) {
    if (!cart || kidsEscribiendo) return Promise.resolve(cart);
    if (!kidsPedidoRoto(cart)) return Promise.resolve(cart);
    var edades = [];
    (cart.items || []).forEach(function (it) {
      if (esLineaKids(it)) edades = edades.concat(kidsEdadesDeItemJs(it));
    });
    return kidsEscribePedido(edades.slice(0, 3));
  }

  function kidsAplicaQtyEdad(caja, nuevo) {
    if (!caja) return;
    var fila = caja.closest('.cart-item');
    if (!fila) return;
    var edadMix = caja.getAttribute('data-fe-cart-talla-qty');
    var prevMix = parseInt(caja.getAttribute('data-qty-actual'), 10);
    if (isNaN(prevMix)) prevMix = 0;
    nuevo = Math.max(0, Math.min(3, parseInt(nuevo, 10) || 0));
    if (!edadMix || prevMix === nuevo) return;
    var total = 0;
    var edades = [];
    fila.querySelectorAll('[data-fe-cart-talla-qty]').forEach(function (sel) {
      var e = sel.getAttribute('data-fe-cart-talla-qty');
      var n = sel === caja ? nuevo : (parseInt(sel.getAttribute('data-qty-actual'), 10) || 0);
      var i;
      for (i = 0; i < n && total < 3; i++) {
        edades.push(e);
        total += 1;
      }
    });
    kidsEscribePedido(kidsEdadesDePedido(fila, edades));
  }

  function kidsSlotsDe(caja) {
    var edades = [];
    if (!caja) return edades;
    caja.querySelectorAll('[data-fe-cart-slot]').forEach(function (sel) {
      if (sel.value) edades.push(sel.value);
    });
    return edades;
  }

  function kidsEsc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function kidsPintaResumenMix(caja) {
    var abre = caja && caja.querySelector('.fe-cart-edad-caja__abre');
    if (!abre) return;
    var edades = kidsSlotsDe(caja);
    var unicas = [];
    edades.forEach(function (edad) {
      if (unicas.indexOf(edad) === -1) unicas.push(edad);
    });
    var vista = unicas.length === 1 ? unicas : edades;
    abre.innerHTML = vista.map(function (edad, i) {
      var txt = vista.length > 1 ? ('Edad ' + (i + 1) + ':') : 'Edad:';
      return '<span class="fe-cart-edad"><span class="fe-cart-edad__txt">' + txt + '</span><span class="fe-cart-edad__valor">' + kidsEsc(edad) + '</span></span>';
    }).join('');
  }

  function kidsAplicaSlots(caja) {
    if (!caja || kidsEscribiendo) return;
    var inicial = (caja.getAttribute('data-edades') || '').split('|').filter(Boolean);
    var edades = kidsSlotsDe(caja);
    if (!edades.length) return;
    if (edades.join('|') === inicial.join('|')) return;
    kidsEscribePedido(kidsEdadesDePedido(caja.closest('.cart-item'), edades));
  }

  function kidsPropsDe(edades) {
    var props = {};
    (edades || []).forEach(function (edad, i) {
      props['Edad ' + (i + 1)] = edad;
    });
    return props;
  }

  function kidsAjustaEdades(edades, dest) {
    var lista = (edades || []).slice();
    var i;
    if (dest < 1) return [];
    if (lista.length === 0) lista = ['1–3 años'];
    if (lista.length > dest) return lista.slice(0, dest);
    for (i = lista.length; i < dest; i++) lista.push(lista[lista.length - 1]);
    return lista;
  }

  function ahorroKidsCents(n, caja) {
    var envio = caja ? parseInt(caja.getAttribute('data-envio-cents') || '495', 10) : 495;
    var gar = caja ? parseInt(caja.getAttribute('data-garantia-cents') || '995', 10) : 995;
    var lista = n * 4495;
    var pago = lista;
    if (n === 2) pago = 7195;
    else if (n >= 3) pago = 9495 + Math.max(0, n - 3) * 3165;
    var pack = Math.max(0, lista - pago);
    var total = pack;
    if (n >= 1) total += envio + gar;
    return total;
  }

  function pintaAhorro(cart) {
    var caja = document.querySelector('[data-fe-cart-totales]');
    var kidsN = cuentaKids(cart);
    var itemCount = cart && cart.item_count != null ? cart.item_count : 0;
    var soloKids = (caja && caja.hasAttribute('data-fe-kids')) || (kidsN > 0 && kidsN === itemCount);
    var filas = document.querySelectorAll('[data-fe-cart-ahorro-fila]');
    /* Tapones: el ahorro del pack va junto al precio de la línea, no en el total. */
    if (!soloKids) {
      filas.forEach(function (fila) { fila.hidden = true; });
      return;
    }
    // Ahorro real de Shopify (descuento automático de pack), no una tabla local.
    var ahorro = kidsN > 0 ? ((cart && cart.total_discount) || 0) : 0;
    var ref = document.querySelector('.totals__total-value');
    filas.forEach(function (fila) {
      if (ahorro <= 0) {
        fila.hidden = true;
        return;
      }
      fila.hidden = false;
      var destino = fila.querySelector('[data-fe-cart-ahorro]');
      if (destino) destino.textContent = '- ' + formatea(ahorro, ref || destino);
    });
  }

  function pintaDesdeCart(cart) {
    if (!cart) return;
    guardaLinea(cart);
    pintaBurbuja(cart.item_count || 0);
    if (typeof cart.total_price === 'number') {
      // El total real de Shopify ya incluye el descuento automático de pack.
      document.querySelectorAll('.totals__total-value').forEach(function (el) {
        el.textContent = formatea(cart.total_price, el);
      });
    }
    if (!cart.items || !cart.items.length) {
      claveGuardada = '';
      varianteGuardada = '';
    }
    pintaAhorro(cart);
    var linea = cart.items && cart.items[0];
    if (linea && document.querySelector('.fe-cart-packs__opcion')) {
      pintaPackLocal(linea.quantity);
      if (typeof linea.final_line_price === 'number') {
        document.querySelectorAll('.cart-item__price-wrapper .price').forEach(function (el) {
          if (el.closest('s')) return;
          if (el.closest('.cart-item--kids')) return;
          el.textContent = formatea(linea.final_line_price, el);
        });
        if (monedaActiva() === 'MXN') {
          var packLinea = (cart.items || []).filter(function (it) {
            return it.quantity === 2 || it.quantity === 4 || it.quantity === 6;
          })[0] || linea;
          var qtyPack = packLinea.quantity || 0;
          var precioMx = precioPackCents(qtyPack);
          if (precioMx) {
            document.querySelectorAll('.totals__total-value').forEach(function (el) {
              el.textContent = formateaMxn(precioMx);
            });
            document.querySelectorAll('[data-fe-pack-precio], .cart-item__price-wrapper .price').forEach(function (el) {
              if (el.closest('s') || el.matches('s')) return;
              if (el.closest('.cart-item--kids')) return;
              el.textContent = formateaMxn(precioMx);
            });
          }
        }
      }
    }
    var pagar = document.getElementById('CartDrawer-Checkout');
    if (pagar && cart.item_count > 0) pagar.disabled = false;
  }

  function botonesDe(form) {
    var lista = [];
    if (form) {
      lista = lista.concat(Array.prototype.slice.call(form.querySelectorAll('button[name="add"]')));
      var formId = form.getAttribute('id');
      if (formId) {
        lista = lista.concat(Array.prototype.slice.call(document.querySelectorAll('button[form="' + formId + '"]')));
      }
    }
    return lista;
  }

  function marcaBoton(btn, estado) {
    if (!btn) return;
    if (estado === 'enviando') {
      if (!btn.getAttribute('data-fe-original')) btn.setAttribute('data-fe-original', btn.innerHTML);
      btn.setAttribute('aria-busy', 'true');
      var texto = btn.getAttribute('data-v2-enviando') || btn.getAttribute('data-fe-enviando') || 'Aplicando oferta';
      if (btn.tagName === 'A') {
        if (!btn.getAttribute('data-fe-original-txt')) btn.setAttribute('data-fe-original-txt', btn.textContent.trim());
        btn.textContent = texto;
      } else {
        btn.textContent = texto;
      }
      return;
    }
    if (estado === 'ok') {
      btn.removeAttribute('aria-busy');
      btn.classList.add('v2-btn--hecho');
      var hecho = btn.getAttribute('data-v2-hecho') || 'Añadido al carrito';
      btn.innerHTML = '<span>' + hecho + '</span>';
      setTimeout(function () {
        btn.classList.remove('v2-btn--hecho');
        var orig = btn.getAttribute('data-fe-original');
        if (orig) btn.innerHTML = orig;
      }, 1800);
      return;
    }
    btn.removeAttribute('aria-busy');
    btn.classList.remove('v2-btn--hecho');
    var orig = btn.getAttribute('data-fe-original');
    if (orig) btn.innerHTML = orig;
  }

  function leeEnlace(href) {
    var id = '';
    var quantity = '1';
    try {
      var url = new URL(href, window.location.origin);
      id = url.searchParams.get('id') || '';
      quantity = url.searchParams.get('quantity') || '1';
    } catch (e) {
      var mId = String(href).match(/[?&]id=(\d+)/);
      var mQty = String(href).match(/[?&]quantity=(\d+)/);
      if (mId) id = mId[1];
      if (mQty) quantity = mQty[1];
    }
    return { id: id, quantity: quantity };
  }

  function varianteDe(opciones) {
    if (opciones.id) return String(opciones.id);
    if (opciones.form) {
      var input = opciones.form.querySelector('[name="id"]');
      if (input && input.value) return String(input.value);
    }
    return '';
  }

  function cantidadDe(opciones) {
    if (opciones.quantity != null && opciones.quantity !== '') return String(opciones.quantity);
    if (opciones.form) {
      var input = opciones.form.querySelector('[name="quantity"]');
      if (input && input.value) return String(input.value);
    }
    return '1';
  }

  function fetchTope(url, opts, ms) {
    var control = ('AbortController' in window) ? new AbortController() : null;
    var corta = null;
    var fetchOpts = opts || {};
    if (control) {
      fetchOpts.signal = control.signal;
      corta = setTimeout(function () { control.abort(); }, ms || 10000);
    }
    return fetch(url, fetchOpts).then(function (r) {
      if (corta) clearTimeout(corta);
      return leeJson(r);
    }, function (err) {
      if (corta) clearTimeout(corta);
      throw err;
    });
  }

  function aplicaCartYSecciones(cart, sections) {
    if (cart) pintaDesdeCart(cart);
    bloqueaPagar(false);
    if (hayLinea()) {
      cierraCarga();
      return Promise.resolve();
    }
    if (sections) {
      pintaSecciones(sections, cart && cart.item_count);
      if (hayLinea()) return Promise.resolve();
    }
    return pideSecciones()
      .then(function (secs) {
        pintaSecciones(secs, cart && cart.item_count);
      })
      .catch(function () {})
      .then(function () {
        cierraCarga();
      });
  }

  function cambiaCantidad(key, cantidad) {
    return fetchTope(urlChange() + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: parseInt(cantidad, 10)
      })
    }).then(function (datos) {
      if (datos && datos.status) {
        return Promise.reject(datos);
      }
      if (datos && datos.item_count != null) pintaDesdeCart(datos);
      else guardaLinea(datos);
      return datos;
    });
  }

  function quitaLinea(key) {
    if (!key) return Promise.resolve();
    bloqueaPagar(true);
    return fetchTope(urlChange() + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
        sections: SECCIONES.join(','),
        sections_url: window.location.pathname || '/'
      })
    }).then(function (cart) {
      if (cart && cart.status) return Promise.reject(cart);
      if (cart && cart.sections) pintaSecciones(cart.sections, cart.item_count);
      if (cart) pintaDesdeCart(cart);
      bloqueaPagar(false);
      cierraCarga();
      return cart;
    }).catch(function () {
      bloqueaPagar(false);
      cierraCarga();
      return pideSecciones().then(function (secs) {
        pintaSecciones(secs);
      }).catch(function () {});
    });
  }

  function cambiaCantidadLinea(key, qty) {
    if (!key) return Promise.resolve();
    qty = parseInt(qty, 10);
    if (isNaN(qty) || qty < 0) return Promise.resolve();
    if (qty === 0) return quitaLinea(key);
    if (kidsCambioEnVuelo) return Promise.resolve();
    kidsCambioEnVuelo = true;
    window.__feKidsLock = true;
    bloqueaPagar(true);
    return fetchTope(urlChange() + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: SECCIONES.join(','),
        sections_url: window.location.pathname || '/'
      })
    }).then(function (cart) {
      if (cart && cart.status) return Promise.reject(cart);
      if (cart && cart.sections) pintaSecciones(cart.sections, cart.item_count);
      if (cart) pintaDesdeCart(cart);
      return cart;
    }).catch(function () {
      return pideSecciones().then(function (secs) {
        pintaSecciones(secs);
      }).catch(function () {});
    }).then(function () {
      kidsTrasCambio();
    });
  }

  function cambiaTalla(key, nuevaId, cantidad, propiedades) {
    if (!key || !nuevaId) return Promise.resolve();
    var linea = {
      id: Number(nuevaId),
      quantity: parseInt(cantidad, 10) || 1
    };
    if (propiedades) linea.properties = propiedades;
    return kidsSustituyeLinea(key, [linea]);
  }

  function kidsSustituyeLinea(key, items) {
    if (!key || !items || !items.length) return Promise.resolve();
    bloqueaPagar(true);
    /* Primero quitar la línea vieja. Si se añade antes y la variante
       coincide, Shopify fusiona y el remove posterior borra también lo nuevo. */
    return fetchTope(urlChange() + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    }).then(function (rmRes) {
      if (rmRes && rmRes.status) return Promise.reject(rmRes);
      return fetchTope(urlAdd() + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: SECCIONES.join(','),
          sections_url: window.location.pathname || '/'
        })
      });
    }).then(function (addRes) {
      if (addRes && addRes.status) return Promise.reject(addRes);
      var secs = addRes && addRes.sections;
      if (secs) pintaSecciones(secs);
      return pideCart().then(function (cart) {
        if (cart) pintaDesdeCart(cart);
        if (secs && hayLinea()) return cart;
        return pideSecciones().then(function (s) {
          pintaSecciones(s, cart && cart.item_count);
          return cart;
        });
      });
    }).then(function (cart) {
      bloqueaPagar(false);
      cierraCarga();
      return cart;
    }).catch(function () {
      bloqueaPagar(false);
      cierraCarga();
      return pideSecciones().then(function (secs) {
        pintaSecciones(secs);
      }).catch(function () {});
    });
  }

  function itemsDe(opciones) {
    if (opciones.items && opciones.items.length) return opciones.items;
    if (opciones.form) {
      var campo = opciones.form.querySelector('#v2-pack-items');
      if (campo && campo.value) {
        try {
          var arr = JSON.parse(campo.value);
          if (Array.isArray(arr) && arr.length) return arr;
        } catch (e) {}
      }
    }
    return null;
  }

  function anadeNuevo(opciones) {
    var items = itemsDe(opciones);
    if (items && items.length) {
      var cuerpo = {
        items: items.map(function (it) {
          var fila = { id: Number(it.id), quantity: parseInt(it.quantity, 10) || 1 };
          if (it.properties) fila.properties = it.properties;
          return fila;
        }),
        sections: SECCIONES.join(','),
        sections_url: window.location.pathname || '/'
      };
      return fetchTope(urlAdd() + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(cuerpo)
      }).then(function (respuesta) {
        if (respuesta && respuesta.status) {
          return Promise.reject(respuesta);
        }
        guardaLinea(respuesta);
        return respuesta;
      });
    }

    var id = varianteDe(opciones);
    var quantity = cantidadDe(opciones);
    if (opciones.href && !id) {
      var parsed = leeEnlace(opciones.href);
      id = parsed.id;
      quantity = parsed.quantity || quantity;
    }
    if (!id) {
      return Promise.reject({
        status: 422,
        description: 'No hemos podido añadir este pack. Recarga la página e inténtalo otra vez.'
      });
    }
    var datos = new FormData();
    datos.append('id', id);
    datos.append('quantity', String(quantity || 1));
    datos.append('sections', SECCIONES.join(','));
    datos.append('sections_url', window.location.pathname || '/');

    return fetchTope(urlAdd() + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: datos
    }).then(function (respuesta) {
      if (respuesta && respuesta.status) {
        return Promise.reject(respuesta);
      }
      guardaLinea(respuesta);
      return respuesta;
    });
  }

  function ejecutaAnadir(opciones) {
    opciones = opciones || {};
    var form = opciones.form || null;
    var boton = opciones.boton || null;
    var id = opciones.id;
    var quantity = opciones.quantity;

    if (opciones.href && !id) {
      var parsed = leeEnlace(opciones.href);
      id = parsed.id;
      quantity = parsed.quantity;
    }

    if (!form && !id) return Promise.resolve();

    var vacio = !hayLinea() && !claveGuardada;
    if (window.feOfertaTiempo && typeof window.feOfertaTiempo.reservar === 'function') {
      var cajaMin = document.querySelector('[data-fe-cart-cuenta]');
      var mins = cajaMin ? parseInt(cajaMin.getAttribute('data-minutos'), 10) : 15;
      window.feOfertaTiempo.reservar(mins);
      if (typeof window.fePintaReserva === 'function') window.fePintaReserva();
    }
    abreCajon(vacio);
    bloqueaPagar(true);
    botonesDe(form).concat(boton ? [boton] : []).forEach(function (b) {
      marcaBoton(b, 'enviando');
    });

    var qty = cantidadDe({ form: form, quantity: quantity });
    var variante = varianteDe({ form: form, id: id });
    var itemsPack = itemsDe({ form: form, items: opciones.items });
    var linea = lineaActual();
    // Un add que trae una lista de items (p. ej. las almohadas kids, una línea
    // por talla) se añade tal cual por anadeNuevo, sin reconciliación de bundle.
    var packKids = !!(itemsPack && itemsPack.length);
    var misma = hayLinea() && linea && linea.key && variante && linea.variant &&
      String(linea.variant) === String(variante) &&
      !packKids;

    if (misma) pintaPackLocal(qty);

    function alAnadir(respuesta) {
      if (packKids) {
        // Add de varias líneas (almohadas kids). Repintar todo desde el carrito.
        var secsAdd = respuesta && respuesta.sections;
        if (secsAdd) pintaSecciones(secsAdd, cuentaDeRespuesta(respuesta));
        return pideCart()
          .then(function (cart) {
            return aplicaCartYSecciones(cart, secsAdd || null);
          })
          .catch(function () { cierraCarga(); });
      }
      if (respuesta && respuesta.sections && !hayLinea()) {
        pintaSecciones(respuesta.sections, respuesta.quantity || 1);
      }
      if (hayLinea()) {
        if (respuesta && respuesta.quantity) pintaPackLocal(respuesta.quantity);
        if (respuesta && typeof respuesta.final_line_price === 'number') {
          document.querySelectorAll('.cart-item__price-wrapper .price').forEach(function (el) {
            if (el.closest('s')) return;
            el.textContent = formatea(respuesta.final_line_price, el);
          });
        }
        pintaBurbuja(respuesta.quantity || 1);
        var el = cajon();
        if (el && typeof el.open === 'function') el.open();
        return;
      }
      return pideCart()
        .then(function (cart) {
          return aplicaCartYSecciones(cart, respuesta && respuesta.sections);
        })
        .catch(function () {
          cierraCarga();
        });
    }

    var pedidoAdd = { form: form, id: id, quantity: quantity, href: opciones.href };
    var trabajo;
    if (misma) {
      trabajo = cambiaCantidad(linea.key, qty).then(function (cart) {
          return aplicaCartYSecciones(cart, null);
        }, function (err) {
          claveGuardada = '';
          return anadeNuevo(pedidoAdd).then(alAnadir);
        });
    } else {
      trabajo = anadeNuevo(pedidoAdd).then(alAnadir);
    }

    return trabajo.then(function () {
      botonesDe(form).concat(boton ? [boton] : []).forEach(function (b) { marcaBoton(b, 'ok'); });
      publica(true, '');
      bloqueaPagar(false);
      cierraCarga();
    }, function (err) {
      var motivo = (err && (err.description || err.message)) ||
        'No hemos podido añadirlo al carrito. Vuelve a intentarlo.';
      if (/parámetro lineal|id or line|identificaci[oó]n/i.test(motivo)) {
        motivo = 'No hemos podido añadir este pack. Vuelve a pulsar el botón.';
      }
      bloqueaPagar(false);
      cierraCarga();
      if (!hayLinea() && !claveGuardada) {
        var el = cajon();
        if (el) el.classList.add('is-empty');
      }
      botonesDe(form).concat(boton ? [boton] : []).forEach(function (b) { marcaBoton(b, 'error'); });
      publica(false, motivo);
    });
  }

  function anadir(opciones) {
    opciones = opciones || {};
    if (addEnVuelo) {
      addCola = opciones;
      abreCajon(false);
      return Promise.resolve();
    }
    addEnVuelo = true;
    return ejecutaAnadir(opciones).then(function () {
      addEnVuelo = false;
      if (addCola) {
        var siguiente = addCola;
        addCola = null;
        return anadir(siguiente);
      }
    }, function () {
      addEnVuelo = false;
      if (addCola) {
        var siguiente = addCola;
        addCola = null;
        return anadir(siguiente);
      }
    });
  }

  function enviaPack() {
    var pedido = packCola;
    packCola = null;
    if (!pedido) return;
    if (packEnVuelo) {
      packCola = pedido;
      return;
    }
    packEnVuelo = pedido;
    bloqueaPagar(true);

    cambiaCantidad(pedido.key, pedido.cantidad)
      .then(function (cart) {
        return pideSecciones().then(function (secs) {
          pintaSecciones(secs, cart && cart.item_count);
        }).catch(function () {}).then(function () {
          return cart;
        });
      })
      .then(function () {
        packEnVuelo = null;
        bloqueaPagar(false);
        cierraCarga();
        if (packCola) enviaPack();
      })
      .catch(function () {
        packEnVuelo = null;
        bloqueaPagar(false);
        cierraCarga();
        pideCart().then(pintaDesdeCart).catch(function () {});
        if (packCola) enviaPack();
      });
  }

  function cambiarPack(key, cantidad) {
    if (!key || !cantidad) return;
    claveGuardada = String(key);
    pintaPackLocal(cantidad);
    bloqueaPagar(true);
    packCola = { key: key, cantidad: cantidad };
    if (packReloj) clearTimeout(packReloj);
    packReloj = setTimeout(enviaPack, 40);
  }

  window.feCarrito = {
    anadir: anadir,
    cambiar: cambiarPack
  };

  document.addEventListener('click', function (e) {
    var opcion = e.target.closest && e.target.closest('.fe-cart-packs__opcion');
    if (opcion && opcion.classList.contains('fe-cart-packs__opcion--activa')) {
      var cerrado = opcion.closest('details.fe-cart-packs');
      if (cerrado) cerrado.removeAttribute('open');
    }
    if (!e.target.closest || !e.target.closest('[data-fe-cart-edad-mix]')) {
      document.querySelectorAll('[data-fe-cart-edad-mix][open]').forEach(function (caja) {
        caja.removeAttribute('open');
      });
    }
    var quitarEdad = e.target.closest && e.target.closest('[data-fe-cart-quita-edad]');
    if (quitarEdad) {
      e.preventDefault();
      var filaQuita = quitarEdad.closest('.cart-item');
      var edadQuita = quitarEdad.getAttribute('data-fe-cart-quita-edad');
      if (!filaQuita || !edadQuita) return;
      var quedan = [];
      filaQuita.querySelectorAll('[data-fe-cart-talla-qty]').forEach(function (sel) {
        var eSel = sel.getAttribute('data-fe-cart-talla-qty');
        if (eSel === edadQuita) return;
        var nSel = parseInt(sel.getAttribute('data-qty-actual'), 10) || 0;
        var iSel;
        for (iSel = 0; iSel < nSel; iSel++) quedan.push(eSel);
      });
      kidsEscribePedido(kidsEdadesDePedido(filaQuita, quedan));
      return;
    }
    var quitar = e.target.closest && e.target.closest('[data-fe-cart-quita]');
    if (quitar) {
      e.preventDefault();
      var quitarKey = quitar.getAttribute('data-linea-key');
      if (quitarKey) quitaLinea(quitarKey);
      return;
    }
    var pasoEdad = e.target.closest && e.target.closest('[data-fe-cart-talla-step]');
    if (pasoEdad) {
      e.preventDefault();
      e.stopPropagation();
      var cajaPaso = pasoEdad.closest('[data-fe-cart-talla-qty]');
      if (!cajaPaso) return;
      var prevPaso = parseInt(cajaPaso.getAttribute('data-qty-actual'), 10);
      if (isNaN(prevPaso)) prevPaso = 0;
      var destPaso = pasoEdad.getAttribute('data-fe-cart-talla-step') === 'mas' ? prevPaso + 1 : prevPaso - 1;
      if (destPaso < 0 || destPaso > 3) return;
      kidsAplicaQtyEdad(cajaPaso, destPaso);
      return;
    }
    var kidsQty = e.target.closest && e.target.closest('[data-fe-kids-qty-btn]');
    if (kidsQty) {
      e.preventDefault();
      e.stopPropagation();
      var cajaQty = kidsQty.closest('[data-fe-kids-qty]');
      if (!cajaQty) return;
      var keyQty = cajaQty.getAttribute('data-linea-key');
      var packAhora = parseInt(cajaQty.getAttribute('data-qty-actual'), 10) || 1;
      var dest = kidsQty.getAttribute('data-fe-kids-qty-btn') === 'mas' ? packAhora + 1 : packAhora - 1;
      if (!keyQty) return;
      if (dest > 10) return;
      cambiaCantidadLinea(keyQty, dest);
      return;
    }
    var boton = e.target.closest && e.target.closest('[data-fe-cart-subir]');
    if (!boton) return;
    e.preventDefault();
    var key = boton.getAttribute('data-linea-key');
    var cantidad = boton.getAttribute('data-cantidad');
    if (!key || !cantidad) return;
    cambiarPack(key, cantidad);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.id === 'CartDrawer-Form' ? e.target : null;
    if (!form) return;
    var quien = e.submitter;
    if (quien && (quien.name === 'checkout' || quien.id === 'CartDrawer-Checkout')) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  /* Cambiar la talla de una o varias líneas de almohada dentro del cajón:
     quita las líneas afectadas y añade las variantes de las tallas nuevas.
     Debounce 450 ms + acumulador por línea, para no perder un cambio si se
     tocan dos desplegables seguidos. */
  var tallaLineaDeb = 0;
  var tallaLineaPend = {};
  var kidsMixDeb = 0;
  var kidsMixCaja = null;
  var kidsCambioEnVuelo = false;

  function kidsTrasCambio() {
    kidsCambioEnVuelo = false;
    window.__feKidsLock = false;
    bloqueaPagar(false);
    cierraCarga();
    if (document.querySelector('cart-items') && !document.querySelector('cart-drawer.active')) {
      window.location.reload();
    }
  }

  function kidsAplicaCambios(updates, addItems) {
    var hayUpdate = false;
    var k;
    for (k in updates) {
      if (Object.prototype.hasOwnProperty.call(updates, k)) hayUpdate = true;
    }
    if (!hayUpdate && (!addItems || !addItems.length)) return Promise.resolve();
    if (kidsCambioEnVuelo) return Promise.resolve();
    kidsCambioEnVuelo = true;
    window.__feKidsLock = true;
    bloqueaPagar(true);
    var paso = Promise.resolve();
    if (hayUpdate) {
      paso = fetchTope(urlUpdate() + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: SECCIONES.join(','),
          sections_url: window.location.pathname || '/'
        })
      });
    }
    return paso.then(function (res) {
      if (res && res.status) return Promise.reject(res);
      if (!addItems || !addItems.length) {
        if (res && res.sections) {
          pintaSecciones(res.sections);
          return res;
        }
        return pideSecciones().then(function (s) { pintaSecciones(s); });
      }
      return fetchTope(urlAdd() + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: addItems,
          sections: SECCIONES.join(','),
          sections_url: window.location.pathname || '/'
        })
      }).then(function (addRes) {
        if (addRes && addRes.status) return Promise.reject(addRes);
        if (addRes && addRes.sections) {
          pintaSecciones(addRes.sections);
          return addRes;
        }
        return pideSecciones().then(function (s) { pintaSecciones(s); });
      });
    }).catch(function () {
      return pideSecciones().then(function (s) { pintaSecciones(s); }).catch(function () {});
    }).then(function () {
      kidsTrasCambio();
    });
  }

  function kidsSeparaLinea(key, nActual, addItems) {
    if (!key || kidsCambioEnVuelo) return Promise.resolve();
    nActual = parseInt(nActual, 10);
    if (isNaN(nActual) || nActual < 0) return Promise.resolve();
    addItems = addItems || [];
    kidsCambioEnVuelo = true;
    window.__feKidsLock = true;
    bloqueaPagar(true);
    return fetchTope(urlChange() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: nActual
      })
    }).then(function (res) {
      if (res && res.status) return Promise.reject(res);
      if (!addItems.length) {
        if (res && res.sections) pintaSecciones(res.sections, res.item_count);
        else {
          return pideSecciones().then(function (s) {
            pintaSecciones(s, res && res.item_count);
          });
        }
        return res;
      }
      return fetchTope(urlAdd() + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: addItems,
          sections: SECCIONES.join(','),
          sections_url: window.location.pathname || '/'
        })
      }).then(function (addRes) {
        if (addRes && addRes.status) return Promise.reject(addRes);
        if (addRes && addRes.sections) pintaSecciones(addRes.sections);
        else return pideSecciones().then(function (s) { pintaSecciones(s); });
        return addRes;
      });
    }).catch(function () {
      return pideSecciones().then(function (s) { pintaSecciones(s); }).catch(function () {});
    }).then(function () {
      kidsTrasCambio();
    });
  }

  function kidsAplicaMixLinea(caja) {
    if (!caja || kidsCambioEnVuelo) return;
    var key = caja.getAttribute('data-linea-key');
    var varActual = String(caja.getAttribute('data-variante') || '');
    var qtyOrig = parseInt(caja.getAttribute('data-qty'), 10) || 0;
    var edades = kidsSlotsDe(caja);
    if (!key || !edades.length) return;
    var porId = {};
    var orden = [];
    edades.forEach(function (edad) {
      var id = kidsIdPorEdad(edad);
      if (!id) return;
      if (!porId[id]) { porId[id] = 0; orden.push(id); }
      porId[id] += 1;
    });
    var nActual = porId[varActual] || 0;
    if (orden.length === 1 && String(orden[0]) === varActual && nActual === qtyOrig) return;
    var addItems = [];
    orden.forEach(function (id) {
      if (String(id) === varActual) return;
      addItems.push({ id: Number(id), quantity: porId[id] });
    });
    kidsSeparaLinea(key, nActual, addItems);
  }

  function aplicaTallaLinea() {
    var pend = tallaLineaPend;
    tallaLineaPend = {};
    var keys = Object.keys(pend);
    if (!keys.length) return;
    var updates = {};
    var addItems = [];
    keys.forEach(function (k) {
      var p = pend[k];
      var vid = kidsIdPorEdad(p.edad);
      if (!vid) return;
      if (p.varActual && String(vid) === String(p.varActual)) return;
      updates[k] = 0;
      addItems.push({ id: Number(vid), quantity: p.qty || 1 });
    });
    kidsAplicaCambios(updates, addItems);
  }

  document.addEventListener('change', function (e) {
    if (window.__feKidsLock || kidsCambioEnVuelo) return;
    var slot = e.target.closest && e.target.closest('[data-fe-cart-slot]');
    if (slot) {
      e.stopPropagation();
      var cajaMix = slot.closest('[data-fe-cart-edad-mix]');
      kidsPintaResumenMix(cajaMix);
      kidsMixCaja = cajaMix;
      clearTimeout(kidsMixDeb);
      kidsMixDeb = setTimeout(function () {
        var caja = kidsMixCaja;
        kidsMixCaja = null;
        kidsAplicaMixLinea(caja);
      }, 450);
      return;
    }
    var sel = e.target.closest && e.target.closest('[data-fe-cart-talla-linea]');
    if (!sel) return;
    e.stopPropagation();
    var key = sel.getAttribute('data-linea-key');
    if (!key) return;
    tallaLineaPend[key] = {
      edad: sel.value,
      qty: parseInt(sel.getAttribute('data-qty'), 10) || 1,
      varActual: sel.getAttribute('data-variante')
    };
    clearTimeout(tallaLineaDeb);
    tallaLineaDeb = setTimeout(aplicaTallaLinea, 450);
  }, true);

  var cola = window.__feCartCola;
  if (cola && cola.length) {
    anadir(cola[cola.length - 1]);
    window.__feCartCola = [];
  }

  /* Reloj del cajón. Solo cuenta si ya se ha añadido (reservar). */
  (function initReserva() {
    function minutosDeCaja() {
      var caja = document.querySelector('[data-fe-cart-cuenta]');
      var m = caja ? parseInt(caja.getAttribute('data-minutos'), 10) : 15;
      return (!m || m < 1) ? 15 : m;
    }

    function dosDigitos(n) { return n < 10 ? '0' + n : String(n); }

    function aplicaFase(caja, estado) {
      caja.classList.toggle('fe-cart-reserva--espera', estado.pendiente);
      caja.classList.toggle('fe-cart-reserva--aviso', estado.fase === 'aviso');
      caja.classList.toggle('fe-cart-reserva--urgente', estado.fase === 'urgente' || estado.fase === 'critico');
      caja.classList.toggle('fe-cart-reserva--cero', estado.cero);
      if (caja.hasAttribute('data-fe-kids-reserva')) return;
      var titulo = caja.querySelector('[data-fe-cart-titulo]');
      if (titulo) titulo.textContent = estado.titulo;
      var pie = caja.querySelector('[data-fe-cart-pie]');
      if (pie) {
        pie.textContent = estado.pie || '';
        pie.hidden = !estado.pie;
      }
    }

    function pinta() {
      var cajas = document.querySelectorAll('[data-fe-cart-cuenta]');
      if (!cajas.length || !window.feOfertaTiempo) return;
      var estado = window.feOfertaTiempo.tick(minutosDeCaja());
      var texto = estado.pendiente
        ? ''
        : dosDigitos(Math.floor(estado.segundos / 60)) + ':' + dosDigitos(estado.segundos % 60);
      for (var i = 0; i < cajas.length; i++) {
        var caja = cajas[i];
        var reloj = caja.querySelector('[data-fe-cart-reloj]');
        if (reloj) reloj.textContent = texto || '--:--';
        aplicaFase(caja, estado);
      }
    }

    window.fePintaReserva = pinta;
    pinta();
    setInterval(pinta, 1000);
    document.addEventListener('fev2:oferta', pinta);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) pinta();
    });
  })();
})();
